import { StyledPullToRefresh } from '@eventr/common-storybook'
import { useShallow } from 'zustand/react/shallow'
import { bs, useBoundStore } from '../../state/bound.store'
import { homeTabSignal } from '../../state/itineraryState/itinerarySignals'
import { useScrollContext } from '../../state/scrollState/scrollContext'
import ItineraryMap from '../components/map/map'
import { Summary } from '../Summary'
import { Itinerary } from '../team/Itinerary'
import { ButtonsAndArrowsDisplayedHome } from './homeButtonsAndArrows'

export const HasItinerariesInstrunctionsHome = () => {
    const { headerHeight } = useScrollContext(
        useShallow((s) => ({ headerHeight: s.headerHeight }))
    )
    return (
        <>
            {homeTabSignal.value === 'map' && <ItineraryMap />}

            {homeTabSignal.value !== 'map' && (
                <StyledPullToRefresh
                    onRefresh={async () => {
                        /// Nothing
                    }}
                    promiseFunction={async () => {
                        if (headerHeight < 100) {
                            useScrollContext.getState().setAtTop(true)
                        }
                        useBoundStore.setState({ refreshKey: Math.random() })
                        const promises = [
                            bs().fetchUsers(),
                            bs().getProfile(),
                            bs().forceItineraryMapUpdate(),
                            bs().fetchOrgConfig(),
                        ]
                        await Promise.all(promises)
                    }}
                    maxPullDownDistance={100}
                >
                    <>
                        {homeTabSignal.value === 'itinerary' && <Itinerary />}
                        {homeTabSignal.value === 'summary' && <Summary />}
                    </>
                </StyledPullToRefresh>
            )}

            <ButtonsAndArrowsDisplayedHome />
        </>
    )
}
